import TextInput from "components/input/TextInput";
import classNames from "classnames";
import styles from "components/cards/referralCard.module.scss";
import useTranslation from "next-translate/useTranslation";

const ReferralCard = (props) => {
    const {order} = props;

    if (!Boolean(order?.referral_code && order?.referral_discount_rate)) {
        return null;
    }

    const {t} = useTranslation('sections-checkout-CheckoutCouponInfoSection');
    const code = order?.referral_code;
    const text = `${order?.referral_discount_rate}` + t('ReferralCard.discount');

    return (
        <div className={styles.root}>
            <div className={styles.titleWrapper}>
                <div>
                    {t('ReferralCard.title')}
                </div>
                <div className={styles.titleHighlight}>
                    ({code})
                </div>
            </div>
            <div className={classNames(styles.textInputWrapper)}>
                <TextInput placeholder={text} disabled value={''}/>
            </div>
            <div style={{height: 20}}/>
        </div>
    )
}

export default ReferralCard;
